import styled from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import Button from "../../atoms/Button";

export const OuterContainer = styled.div`
  padding: 30px 0px 120px;
  background-color: ${colors.blue};
`;

export const ChallengeTitle = styled.h3`
  font-size: 25px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 25px;
  padding: 0 20px;
`;

export const WineCardsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding: 0 20px;
  z-index: 1;
`;

export const ChallengesWinesRelativeContainer = styled.div`
  position: relative;
`;

export const ChallengeWinesGradientContainer = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background-image: linear-gradient(180deg, rgba(196, 196, 196, 0) 3.14%, ${colors.blue} 39.8%);
  opacity: 0.5;
  z-index: 2;
`;

export const StyledButtonContainer = styled.div`
  padding: 0 20px;
`;

export const StyledButton = styled(Button).attrs(() => ({
  full: true,
  lg: true,
  ghost: true,
}))`
  margin-bottom: 32px;
`;

export const StyledExplorerImage = styled.img`
  max-height: 132px;
  margin-bottom: 24px;
`;

export const PlaceholderText = styled.div`
  font-size: 22px;
  font-family: ${fonts.fontInterstateBlackCompressed};
  line-height: 26px;
  text-align: center;
  max-width: 60%;
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`;
